<template>
  <div class="relative w-full h-full video-hero">
    <video class="object-cover w-full h-full" autoplay muted loop ref="video">
      <source :src="video" type="video/mp4" />
      <slot name="fallback-image" />
    </video>
    <div v-if="currentSlide" class="absolute bottom-0 w-full gradient">
      <div class="container">
        <transition name="slide-fade" mode="out-in">
          <h1 :key="currentSlide.text" v-html="currentSlide.text" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find';

export default {
  props: {
    video: { required: true, type: String }
  },

  data() {
    return {
      currentTime: 0,
      slides: [
        { time: [0, 2.6], text: 'Serving governments' },
        { time: [2.6, 5.6], text: 'Supporting voices<br>of the most vulnerable' },
        { time: [5.6, 8.6], text: 'Building partnerships for impact' },
        { time: [8.6, 11.6], text: 'Elevating evidence' },
        { time: [11.6, 15], text: 'A region united to defeat malaria' }
      ]
    };
  },

  computed: {
    currentSlide() {
      return find(
        this.slides,
        (slide) => slide.time[0] <= this.currentTime && slide.time[1] > this.currentTime
      );
    }
  },

  mounted() {
    this.$refs.video.ontimeupdate = () => {
      this.currentTime = this.$refs.video?.currentTime || 0;
    };
  }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
